<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="draft-container"
  (onHide)="visibleChange.emit(false)"
  [draggable]="false"
>
  <ng-template pTemplate="header">
    <div class="draft-modal-header">
      <h2>{{ data.title || "Cancel Draft" }}</h2>
    </div>
  </ng-template>

  <div class="draft-modal-body">
    <p class="draft-msg">
      The user details are not saved. <br />
      Your data will be saved as a draft.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <button class="draft-btn-outline" (click)="onCancel()">No</button>
    <button class="draft-btn-primary" (click)="onConfirm()">Yes</button>
  </ng-template>
</p-dialog>
